/**
 * 插件加载器
 */
import importHTML from 'import-html-entry';

export async function pluginLoad(entry: string) {
  if (!entry.endsWith('.html') && !entry.includes('.html?')) {
    console.error(`[@wakeadmin/bay] 插件入口必须是html文件, 但是接收到的是：${entry}`);
    return;
  }

  try {
    const styles: string[] = [];
    const response = await importHTML(entry, {
      getTemplate(tpl) {
        const container = document.createElement('div');
        container.innerHTML = tpl;

        const styleLinks = container.querySelectorAll('link[rel="stylesheet"]');

        styleLinks.forEach(link => {
          const href = link.getAttribute('href');
          if (href) {
            styles.push(href);
          }

          link.remove();
        });

        return container.innerHTML;
      },
    });

    const inlineStyles = await response.getExternalStyleSheets();

    // 插入样式
    for (const style of styles) {
      const styleElement = document.createElement('link');

      styleElement.setAttribute('rel', 'stylesheet');
      styleElement.setAttribute('href', style);
      styleElement.setAttribute('data-plugin', entry);

      document.head.append(styleElement);
    }

    // 插入样式
    for (const styleContent of inlineStyles) {
      const styleElement = document.createElement('style');

      styleElement.innerHTML = styleContent;
      styleElement.setAttribute('data-plugin', entry);

      document.head.append(styleElement);
    }

    // 执行脚本
    response.execScripts();
  } catch (e) {
    console.error(`[bay] 插件加载(${entry})失败:`, e);
  }
}
